import React from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import { IoIosArrowBack } from "react-icons/io";
import Header3 from "./components/Header3";
import TopBarProgress from "react-topbar-progress-indicator";
import Header from "./layouts/Header";
import SideNav from "./layouts/SideNav";
import { BiMenu } from "react-icons/bi";

class Customers extends React.Component {
  constructor(props) {
    super(props);
    const isMobile = window.innerWidth <= 768;
    this.state = {
      details: [],
      query: "",
      loadBarProgress: true,
      isMobile,
      collapsed: isMobile,
    };
  }

  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);

    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    const businessid = localStorage.getItem("businessid");
    document.title = "Customers / " + businessname;

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=CLIENTELE&subquery=GETCLIENTELE&accountid=" +
        businessid +
        "&accounttype=" +
        accounttype,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        if (response.data.val == 0) {
          this.setState({ details: [], loadBarProgress: false });
        } else {
          this.setState({ details: response.data, loadBarProgress: false });
        }
      })
      .catch((error) => console.log(error));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile = () => {
    const isMobile = window.innerWidth <= 768;
    this.setState((prev) => ({
      isMobile,
      collapsed: isMobile ? true : prev.collapsed, // auto-collapse only when entering mobile
    }));
  };

  searchQuery = (text) => {
    let value = text;
    // this.setState({ query: value });
    this.setState({ query: text.target.value });

    let query = text.target.value.split(" ").join("+");
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");
    const accountid = localStorage.getItem("businessid");

    Axios.get(
      "https://karamale.com/apps/kscanner/webservices.php?query=CLIENTELE&subquery=SEARCHCLIENTELE&search=" +
        query +
        "&accountid=" +
        accountid +
        "&accounttype=" +
        accounttype,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        // alert(response.data.val);
        if (response.data.val == 0) {
          this.setState({ details: [] });
        } else {
          this.setState({ details: response.data });
        }
      })
      .catch((error) => console.log(error));
  };

  details = () => {
    let activeString = "";
    const accountid = localStorage.getItem("businessid");
    const businessname = localStorage.getItem("businessname");
    const accounttype = localStorage.getItem("accounttype");

    return (
      <div>
        {this.state.details.length < 1 ? (
          <div>
            <label
              style={{
                width: "100%",
                textAlign: "center",
                fontSize: 13.5,
                color: "#5B7083",
              }}
            >
              No data found{" "}
            </label>
          </div>
        ) : (
          this.state.details.map((item, index) => {
            return (
              <div className={"col-lg-12 p-0"}>
                <Link
                  to={{
                    pathname: "/customerprofile",
                    state: {
                      accountid: localStorage.getItem("businessid"),
                      accounttype: accounttype,
                      clientid: item.clientid,
                      phone: item.phone,
                      clientename: item.fname + " " + item.lname,
                      email: item.email,
                      prevpage: "customers",
                    },
                  }}
                >
                  <div className="row" style={{ display: "flex" }}>
                    <div className="col-12 p-3">
                      <label className="w-100 font-medium cursor-pointer text-black mb-0">
                        {item.fname} {item.lname}
                      </label>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })
        )}
      </div>
    );
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      collapsed: !prevState.collapsed,
    }));
  };

  render() {
    if (localStorage.getItem("businessid") === null) {
      return <Redirect to="/login" />;
      //   return exit(1);
    } else {
    }
    const { loadBarProgress, collapsed, isMobile } = this.state;

    return (
      <div className="view">
        {loadBarProgress && <TopBarProgress />}
        {/* <Header3 /> */}

        <Header />
        <SideNav
          collapsed={this.state.collapsed}
          onToggle={this.handleToggle}
        />

        <div
          className="container mt-5"
          style={{
            marginLeft: this.state.isMobile
              ? "0px"
              : this.state.collapsed
              ? "auto"
              : "auto",
          }}
        >
          {/* ✅ Mobile overlay when sidebar is open */}
          {isMobile && !collapsed && (
            <div
              className="mobile-overlay active"
              onClick={this.handleToggle}
            />
          )}

          {this.state.isMobile && this.state.collapsed && (
            <label className="mobile-toggle" onClick={this.handleToggle}>
              <BiMenu size={25} />
            </label>
          )}
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-7 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-5 col-6 pl-0">
                      <button
                        onClick={() => this.props.history.goBack()}
                        className="link-btn"
                      >
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>

                    <div className="col-lg-7 col-6 p-0">
                      <input
                        type="text"
                        placeholder="Search customer"
                        value={this.state.query}
                        onChange={this.searchQuery}
                        className="search-ticket-input"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className=" BoxDashboardContainer mb-5  pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 pl-0">
                      <label className="ticket-title  pl-0 pr-0">
                        CUSTOMERS
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                {this.details()}
              </div>
            </div>
          </div>
        </div>

        {/* <Footer /> */}
      </div>
    );
  }
}

export default Customers;
